import Smartphones from 'Counterparties/Customers/views/SelectableCustomersView/containers/Smartphones'
import Tablets from 'Counterparties/Customers/views/SelectableCustomersView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const SelectableCustomersView = getCurrentDeviceView(Smartphones, Tablets)

export default SelectableCustomersView
